// extracted by mini-css-extract-plugin
export default {"main":"Layout_main__mIuK3","container":"Layout_container__SRSJA"};